module.exports = __webpack_public_path__ + "static/img/B (22).88b5e44e.png";